import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { DarkShadowDirective } from 'shared/directives/dark-shadow.directive';

@Component({
  selector: 'app-admin-tile',
  standalone: true,
  imports: [CommonModule, MatIconModule, RouterLink, DarkShadowDirective],
  templateUrl: './admin-tile.component.html'
})
export class AdminTileComponent {
  @Input() title: string = '';
  @Input() description: string = '';
  @Input() url: string = '';
  @Input() icon: string = 'tabler_outline:file';
  @Input() badge: number | string | null = null;
  @Input() queryParams: Record<string, string> | null = null;
}
